import { HttpClient, HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { AllocationResponse } from 'src/app/models/allocation-response.model'

@Injectable({
  providedIn: 'root',
})
export class AllocationService {
  public static readonly allocationEndpoint = '/allocation'

  constructor(private readonly http: HttpClient) {}

  getAllocation(
    fundId: string,
    isInternal: boolean,
    isBfpAllocationToggle: boolean,
  ): Observable<AllocationResponse> {
    const params = new HttpParams()
      .set('isInternal', String(isInternal))
      .set('isBfpAllocationToggle', String(isBfpAllocationToggle))
    return this.http.get<AllocationResponse>(
      `vmf/api/${fundId}`.concat(AllocationService.allocationEndpoint),
      { params },
    )
  }
}
